import React from 'react';

const PatientCell = ({ data: { first_name, last_name } }) =>
    <div>
        {`${first_name} ${last_name}`}
    </div>;

export default PatientCell;
